import React from 'react';
import { useParams } from 'react-router';
import { Grid, Button, CircularProgress } from '@mui/material';
import FileCopyIcon from '@mui/icons-material/FileCopy';
import PointOfSaleIcon from '@mui/icons-material/PointOfSale';
import axios from 'axios';
import Config from '../../../../config/Config';

const CopyLink = () => {
    const { RestauId, CateringInquiryId } = useParams();

    const [savingChanges, setSavingChanges] = React.useState(false);

    const linkCustomer =
        'https://order.strideq.com/catering/' +
        RestauId +
        '/' +
        CateringInquiryId;
    const linkKitchen =
        'https://order.strideq.com/catering/' +
        RestauId +
        '/' +
        CateringInquiryId +
        '/' +
        'kitchen';

    const handleCopyCustomer = async () => {
        try {
            await navigator.clipboard.writeText(linkCustomer);
            alert('Order link for customer copied to clipboard!');
        } catch (err) {
            alert('Failed to copy the link');
        }
    };

    const handleCopyKitchen = async () => {
        try {
            await navigator.clipboard.writeText(linkKitchen);
            alert('Order link for kitchen copied to clipboard!');
        } catch (err) {
            alert('Failed to copy the link');
        }
    };

    const pushOrderToPos = async () => {
        if (
            !window.confirm(
                'Are you sure you want to push this order to the POS system?'
            )
        )
            return;

        try {
            setSavingChanges(true);
            let reqBody = {
                restauId: RestauId,
                inquiryId: CateringInquiryId,
                fulfillmentType: 'PICKUP',
            };
            const token = await window.customerApp
                .auth()
                .currentUser.getIdToken();
            const response = await axios.post(
                Config.createSquareOrder,
                reqBody,
                {
                    headers: {
                        token: token,
                        'Content-Type': 'application/json',
                    },
                }
            );

            if (response && response.data && response.data.success) {
                alert('Order pushed to POS successfully!');
            } else {
                alert(
                    'Failed to push order to POS. Error:' + response.data.error
                );
            }
        } catch (err) {
            alert(
                'Failed to push order to POS. Error:' +
                    err.response.data.error || err.message
            );
        }
        setSavingChanges(false);
    };

    return (
        <Grid
            container
            spacing={1}
            sx={{ display: 'flex', alignItems: 'center', mb: 10, mt: 2 }}
        >
            <Grid item xs={12}>
                <Button
                    variant="contained"
                    size="small"
                    startIcon={<FileCopyIcon />}
                    onClick={handleCopyCustomer}
                >
                    Copy order link for customer
                </Button>
            </Grid>

            <Grid item xs={12}>
                <Button
                    variant="contained"
                    size="small"
                    startIcon={<FileCopyIcon />}
                    onClick={handleCopyKitchen}
                >
                    Copy order link for kitchen
                </Button>
            </Grid>

            <Grid item xs={12}>
                <Button
                    variant="contained"
                    size="small"
                    startIcon={<PointOfSaleIcon />}
                    disabled={savingChanges}
                    onClick={pushOrderToPos}
                >
                    Push order to POS
                    {savingChanges && (
                        <CircularProgress
                            size={24}
                            style={{ color: 'black' }}
                        />
                    )}
                </Button>
            </Grid>
        </Grid>
    );
};

export default CopyLink;
